import { Link, styled } from '@mui/material';

export const ChapterTitle = styled(Link)`
  font-size: 14px; /* Updated to match sidebar */
  font-weight: 400;
  line-height: 1.43; /* Using the MUI body2 standard line height */
  letter-spacing: 0.4px;
  color: ${({ theme }) => theme.palette.text.primary};
  text-decoration: none;
  cursor: pointer;

  span {
    font-weight: 400;
  }

  &:hover {
    text-decoration: underline;
  }
`;
